<template>
  <div>
    <PageHeader title="Réglages" />
    <div class="space-y-6">
      <div class="space-y-6">
        <div class="bg-white shadow-sm px-4 py-5 sm:rounded-lg sm:p-6">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <h3 class="text-lg font-medium leading-6 text-gray-900">{{ t("iban_title") }}</h3>
              <p class="mt-1 text-sm text-gray-500">{{ t("iban_description") }}</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <IbanForm />
            </div>
          </div>
        </div>
      </div>

      <NewPassword />
    </div>
  </div>
</template>

<script>
import { PageHeader } from "@estaly/ui";
import { useI18n } from "vue-i18n";
import { mapState } from "vuex";
import NewPassword from "../components/NewPassword.vue";
import IbanForm from "../components/IbanForm.vue";

export default {
  components: {
    PageHeader,
    NewPassword,
    IbanForm,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
  },
};
</script>

<i18n src="./Profile.i18n.json"></i18n>
